/**
 * Copyright (c) 2014-present, Facebook, Inc. All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

'use strict';

module.exports = {
  ValidationError: require('./errors').ValidationError,
  createDidYouMeanMessage: require('./utils').createDidYouMeanMessage,
  format: require('./utils').format,
  logValidationWarning: require('./utils').logValidationWarning,
  validate: require('./validate') };


//////////////////
// WEBPACK FOOTER
// ../~/jest-validate/build/index.js
// module id = 1056
// module chunks = 0